/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./VIPRDecoratable',
	'./VIPRItem'
], function(_, VIPRDecoratable, VIPRItem) {

	// implements ITuple
	class VIPRTuple extends VIPRDecoratable {
		constructor(tuple, context, content, viprItemCache) {
			super(...arguments);

			this.tuple = tuple;
			this.content = content;
			this.context = context;
			this.datapoints = [];
			this.items = [];
			this.dataset = context.dataset;
			this.dataItemIndex  = this.context.index.dataitem;
			this.dataItemFormats  = this.context.index.dataItemFormats;
			this.itemClassSetIndex = this.context.index.itemClassSet;
			this._viprItemCache = viprItemCache;
		}

		destroy() {
			for(const key in this._viprItemCache) {
				this._viprItemCache[key].destroy();
				delete this._viprItemCache[key];
			}
			this._viprItemCache = null;
			this.datapoints = null;
			this.dataset = null;
			this.context = null;
			this.items = null;
		}

		getUniqueName() {
			return this.getItem(0).getUniqueName();
		}

		getCaption() {
			return this.getItem(0).getCaption();
		}

		getParent() {
			return this.getItem(0).getParent();
		}

		getItemClassSetIndex() {
			//Since Enodr release,  a tuple could have a itemClassSetIndex property
			//that indicates which itemClass the current tuple is using
			return this.itemClassSetIndex;
		}

		_createVIPRItem(index, viprTuple, content) {
			const context = viprTuple.context;
			const viprItemInfo = viprTuple.tuple[index];
			let key;
			if (viprItemInfo.d) {
				key = `${viprItemInfo.d}->${viprItemInfo.u}`;
			} else {
				key = `${viprItemInfo.label}->${viprItemInfo.value}`;
			}
			if (!this._viprItemCache[key]) {
				this._viprItemCache[key] = new VIPRItem(this.tuple[index], context, content);
			}
			this._viprItemCache[key].addTuple(viprTuple);
			return this._viprItemCache[key];
		}

		getItem(index) {
			if (index < this.getItemCount() && this.items[index] === undefined) {
				// keep track of the tuple item index as part of the context index
				this.context.index.tupleitem = index;
				this.context.index.dataitem = this.dataItemIndex;
				this.context.index.dataItemFormats = this.dataItemFormats;
				this.context.dataset = this.dataset;
				this.items[index] = this._createVIPRItem(index, this, this.content);
			}
			return this.items[index];
		}

		getItemCount() {
			return this.tuple ? this.tuple.length : 0;
		}

		addDataPoint(datapoint) {
			if (this.datapoints.indexOf(datapoint) === -1) {
				this.datapoints.push(datapoint);
			}
		}

		decorate(action, value) {
			super.decorate(...arguments);
			if (this.datapoints.length > 0) {
				// decorate the datapoints
				_.each(this.datapoints, function(dp) {
					dp.decorate(action, value);
				});
			}
		}
	}

	return VIPRTuple;
});